import { useEffect, useState } from "react";
import { api } from "@/api";
import { Calendar, MapPin, Video } from "lucide-react";

function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fr-CA", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export default function AppointmentsSummaryWidget() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/dashboard/appointments-summary")
      .then((r) => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center text-gray-400 text-sm py-4">Chargement...</div>;
  if (!data) return <div className="text-center text-gray-400 text-sm py-4">Aucune donnée</div>;

  return (
    <div className="space-y-3" data-testid="widget-appointments">
      <div className="bg-violet-50 rounded-lg px-3 py-2">
          <div className="text-[10px] uppercase text-violet-600">7 jours à venir</div>
          <div className="text-xl font-bold text-violet-800">{data.upcoming_7d}</div>
      </div>

      <div className="grid grid-cols-3 gap-1 text-[11px]">
        <div className="text-center px-2 py-1 bg-amber-50 rounded">
          <div className="text-amber-600 uppercase">En attente</div>
          <div className="font-bold text-amber-800">{data.pending}</div>
        </div>
        <div className="text-center px-2 py-1 bg-emerald-50 rounded">
          <div className="text-emerald-600 uppercase">Confirmés</div>
          <div className="font-bold text-emerald-800">{data.confirmed}</div>
        </div>
        <div className="text-center px-2 py-1 bg-blue-50 rounded">
          <div className="text-blue-600 uppercase">Terminés</div>
          <div className="font-bold text-blue-800">{data.completed}</div>
        </div>
      </div>

      {data.next && data.next.length > 0 ? (
        <div>
          <div className="text-[11px] uppercase text-gray-500 mb-1.5">Prochains</div>
          <ul className="space-y-1">
            {data.next.slice(0, 3).map((a) => (
              <li key={a.id} className="flex items-center gap-2 text-xs px-2 py-1.5 bg-gray-50 rounded" data-testid={`widget-appt-${a.id}`}>
                {a.type === "online" ? <Video className="w-3 h-3 text-violet-600 shrink-0" /> : <MapPin className="w-3 h-3 text-violet-600 shrink-0" />}
                <span className="flex-1 truncate text-gray-700 font-medium">{a.title}</span>
                <span className="text-[10px] text-gray-500 shrink-0">{fmtDate(a.start_time)}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="text-center py-3">
          <Calendar className="w-6 h-6 mx-auto text-gray-300" />
          <p className="text-xs text-gray-400 mt-1">Aucun RDV à venir</p>
        </div>
      )}
    </div>
  );
}
